export default function Footer() {
  return (
    <footer className="bg-dark text-white/70 mt-auto">
      <div className="relative overflow-hidden">
        {/* Gradient fade top border */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-lime/40 to-transparent" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img
                  src="/FormalLogoFinal-Square.png"
                  alt="Runninglime"
                  className="h-8 w-8 rounded-lg transition-transform duration-300 hover:scale-110"
                />
                <span className="text-lg font-bold text-white">
                  Beverages<span className="text-lime"> by Runninglime</span>
                </span>
              </div>
              <p className="text-sm text-white/50">
                Premium beverages for businesses who run on lime.
              </p>
            </div>

            {/* Links */}
            <div>
              <h4 className="text-sm font-semibold text-white mb-3">Quick Links</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="/store" className="hover:text-lime hover-underline transition-colors">Browse Store</a></li>
                <li><a href="/orders" className="hover:text-lime hover-underline transition-colors">My Orders</a></li>
                <li><a href="/support" className="hover:text-lime hover-underline transition-colors">Customer Support</a></li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-semibold text-white mb-3">B2B Inquiries</h4>
              <ul className="space-y-2 text-sm">
                <li>beverages@runninglime.com</li>
                <li>Mon - Fri, 9:00 - 18:00 CET</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 mt-8 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs text-white/40">
              &copy; {new Date().getFullYear()} Runninglime. All rights reserved.
            </p>
            <p className="text-xs text-white/30">
              This is a demo storefront.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
